export default __webpack_public_path__ + "static/media/logo-drawer-lee.fe79812e.png";